define('results_view',['bootstrap', 'service__number_translate'], function (news, Numbers) {

    return {

        init: function (elm, vocab, allFeedback) {
            this.elm = elm;
            this.vocab = vocab;
            this.allFeedback = allFeedback;
        },

        setupHtml: function () {
            this.elm.append(
                '<div class="result-section">' +
                    '<div class="result-section__overview"></div>' +
                    '<div class="result-section__score">' +
                        '<div class="result-section__score-label"></div>' +
                        '<div class="result-section__score-numbers"></div>' +
                    '</div>' +
                    '<div class="result-section__image"></div>' +
                    '<div class="result-section__summary"></div>' +
                    '<div class="result-section__share-tools"></div>' +
                '</div>' +
                '<div class="restart-quiz">' +
                    '<p class="restart-quiz__label">' + this.vocab.take_quiz_again + '</p>' +
                    '<button class="quiz-btn quiz-btn--restart">' + this.vocab.restart + '</button>' +
                '</div>'
            );
        },

        render: function (score, outOf, feedback) {
            this.elm.find('.result-section__overview').html(feedback.overview);

            var scoreText = Numbers.translate(this.vocab, score, outOf);

            if (!this.vocab.hideScore) {
                this.elm.find('.result-section__score-label').text(this.vocab.your_score);
                this.elm.find('.result-section__score-numbers').text(scoreText);
                this.elm.find('.result-section__image').hide();
            }

            if (feedback.image) {
                this.elm.find('.result-section__image').html('<img src="' + feedback.image + '" alt="">');
            }

            this.elm.find('.result-section__summary').html('<p>' + feedback.summary + '<p>');
            news.pubsub.emit('quiz:progress', [1, 0]);
        },

        goAway: function () {
            this.elm.removeClass('quiz-content--mode-result');
        }
    };

});

